module.exports = __webpack_public_path__ + "static/media/pgmolIconSelected.0656e0f7.png";